import { call, put, takeLatest } from 'redux-saga/effects';

import { ActionKeys } from '~/actions/constants';
import * as promoActions from '~/actions/promo.actions';
import * as userActions from '~/actions/user.actions';
import { promoFromJSON } from '~/modules/billing/components/PromoCode/utils/promo.util';
import { applyPromoCode, replacePromoCode } from '~/services/promo.service';
import { Events, track } from '~/utils/segment';

export function* applyOrReplacePromoCode(
  action: ReturnType<typeof promoActions.applyOrReplacePromoCode>,
) {
  try {
    const promoCode = action.code.toUpperCase();
    const response = action.isReplacement
      ? yield call(replacePromoCode, promoCode)
      : yield call(applyPromoCode, promoCode);
    const promo = promoFromJSON(response.data);
    if (promo) {
      yield put(promoActions.applyOrReplacePromoCodeSuccess());
      yield put(userActions.refreshUser());
      yield call(track, Events.promo_code_add_replace);
    }
  } catch (err) {
    const errorMessage = err?.response?.data?.errors ? err.response.data.errors[0].code : 'UNKNOWN';

    yield put(promoActions.applyOrReplacePromoCodeError(new Error(errorMessage)));
  }
}

export default [takeLatest(ActionKeys.PROMO_CODE_APPLY_OR_REPLACE, applyOrReplacePromoCode)];
